import React, { Component } from 'react';

import CalloutSection from '../Components/CalloutSection'
import Centered from "../Components/Centered";
import TextSection from "../Components/TextSection";
import TopContent from "../Components/TopContent";
import TitleText from "../Components/TitleText";
import LimitedWidthSection from "../Components/LimitedWidthSection";

class Page extends Component {
  render() {
    return (
      <Centered>
        <TopContent>
          <CalloutSection>
            <Centered>
              <div className="spacer-40px" />
              <TitleText>Press</TitleText>
              <div className="spacer-20px" />
              <TextSection>
                <Centered>
                  <div className="spacer-20px" />
                  <LimitedWidthSection>
                    <p align="center">
                      <img width="253" height="65" alt="Biterica" src="/biterica_blue.png"/>
                    </p>
                    <p>
                      <strong>PRESS RELEASE</strong>
                    </p>
                    <p align="center">
                      <strong>Biterica Launches Simple Bitcoin Gifting </strong>
                    </p>
                    <ul>
                      <li>
                        <em>
                          Easy click interface allows gifting of Bitcoin to anyone in the
                          world with an email
                        </em>
                      </li>
                      <li>
                        <em>
                          Innovative platform helps tackle two of cryptocurrency’s most
                          pressing issues: continued adoption by the mainstream general
                          public and provides a real-world use case
                        </em>
                      </li>
                    </ul>
                    <p>
                      <em></em>
                    </p>
                    <p>
                      SAN DIEGO, Calif. – Bitcoin gifting just became faster
                      and easier than ever before with the launch of Biterica, the world's first
                      easy to use Bitcoin gifting platform. Biterica allows someone to instantly
                      give the gift of Bitcoin to anyone in the world with an email address. The
                      platform eliminates many of the common consumer headaches associated with
                      getting into cryptocurrency.
                    </p>
                    <p>
                      “I am excited to unveil Biterica, an easy to use service that allows anyone
                      in the world to instantly give Bitcoin to anyone with an email address,”
                      said <strong>Raz Suprovici</strong>, founder of Biterica. “Most people who
                      are into crypto have either gifted it or had it given to them, but gifting
                      someone Bitcoin is a difficult and convoluted process, so we made it super
                      simple! Whether it’s a high school graduation, Hanukkah or grandchild’s
                      birthday, with Biterica it’s easier than ever to give someone Bitcoin.”
                    </p>
                    <p>
                      Biterica’s mission is to make Bitcoin more accessible by building
                      mainstream tools that make it easy to use by the general public. Biterica
                      relies on both <a href="https://www.blockchain.com/">Blockchain</a> and <a href="https://www.coinbase.com/?r=5151d3810fa7e91c92000005">Coinbase</a>, two of the world's largest
                      wallet providers, to facilitate quick and secure access to funds.
                    </p>
                    <p>
                      Prior to building Biterica, Suprovici previously built MebApp to 15 million
                      monthly users and sold TapBuy to Groupon. He has consulted with numerous
                      Fortune 100 companies and is passionate about Bitcoin’s ability to make the
                      world better, believing anyone can be part of the movement by educating
                      friends and family.
                    </p>
                    <p>
                      “Our goal is to expand the number of people that are into Bitcoin, starting
                      with your friends and family first,” added <strong>Suprovici.</strong>
                      “Bitcoin is how money will work in the future and Biterica makes it easy to
                      help those you care about get in before they get priced out and it’s too
                      late. If you’re going to a Birthday party this weekend, consider giving the
                      $20 gift that everyone at the party is going to talk about. Recipients know
                      it comes with the best intentions, especially 5 years later.”
                    </p>
                    <p>
                      The process is simple. First, the recipient's email address is entered,
                      followed by the sender setting a budget and personal note to accompany the
                      gift. A secure, unique Bitcoin wallet is generated for the recipient and
                      the sender is prompted to fund the gift. A few seconds after the gift is
                      funded, an email is sent to the recipient accompanied by a confirmation
                      receipt to the sender. Once the Bitcoin gift recipient receives the gift,
                      they can instantly log into their wallet, see their Bitcoin and spend it as
                      they please.
                    </p>
                    <p>
                      It’s that simple.
                    </p>
                    <p>
                      For more information, visit    <a href="http://www.biterica.com/">Biterica.com</a>.
                    </p>
                    <p>
                      <strong>About Biterica</strong>
                    </p>
                    <p>
                      Gifting Bitcoin is hard, so we made it incredibly simple. To gift someone
                      Bitcoin, visit <a href="http://www.biterica.com/">Biterica.com</a>.
                    </p>
                    <p align="center">
                      # # #
                    </p>
                  </LimitedWidthSection>
                  <div className="spacer-40px" />
                </Centered>
              </TextSection>
            </Centered>
          </CalloutSection>
        </TopContent>
      </Centered>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/Pages/PressPage.js